import React, { useContext, useEffect, useState } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { useHistory, useLocation } from 'react-router';
import { useForceUpdate } from '../utils/functions';


const AddProduct = () => {


    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const { state, setManufactursGlobal, setProductsGlobal } = useContext(Context)
    const [prodData, setProdData] = useState({
        p_name: '',
        p_price: '',
        p_MSRP: '',
        p_age: '',
        p_status: '1',
        p_color: '',
        p_manufacturer: '',
        p_type: '',
        p_exp_id: '',
        st_id: state.storeData.st_id
    })
    const [manufacturs, setManufacturs] = useState(state?.manufacturs ? state.manufacturs : [])
    const [expiries, setExpiries] = useState(state?.expiries ? state.expiries : [])


    function AddProd(event) {

        event.preventDefault();
        if (prodData.p_name == '') {
            alert('Please enter a valid product name')
            return
        }
        if (prodData.p_manufacturer == '') {
            alert('Please select product manufactur')
            return
        }
        if (prodData.p_price == '') {
            alert('Price must not be zero')
            return
        }
        if (prodData.p_MSRP == '') {
            alert('Price must not be zero')
            return
        }
        if (prodData.p_type == '') {
            alert('please select product type')
            return
        }
        if (prodData.p_age == '') {
            alert('Please select expiry')
            return
        }
        setLoading(true)
        apiRequest(prodData, 'addprod')
            .then(data => {

                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    if (data.products) {
                        setProductsGlobal(data.products)
                    }
                    // alert('Product added')
                    history.replace('viewProducts')
                }
                else {
                    alert(data.error.message)
                }
            })
            .catch(err => {
                console.log(err)
                alert("Network error")
                setLoading(false)
            })

    }

    function getManufacturs() {

        setLoading(true)
        const st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewManufactur')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setManufacturs(data.data);
                    setManufactursGlobal(data.data);
                    // setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }

    function getexpiries() {

        setLoading(true)
        const st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewExpiries')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    // alert('get')
                    setExpiries(data.data)
                    // setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }


    useEffect(() => {
        if (!state.manufacturs.length) {
            getManufacturs()
        }
        getexpiries();

    }, [])


    return (
        <div>
            <div id="wrapper">
                <Sidebar />

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    {/* Main Content */}
                    <div id="content">
                        <Topbar />

                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Heading */}
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">Add Product</h1>
                            </div>
                            <div className="row">
                                <form onSubmit={(e) => { AddProd(e) }}>

                                    <div className="form-group row">

                                        <div className="col-sm-6">
                                            <div className="editDetails" >Name</div>
                                            <input
                                                required
                                                type="text"
                                                name="p_name"
                                                id="p_name"
                                                title="Name"
                                                className="form-control form-control-user"
                                                placeholder="Name"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_name: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Manufacturer</div>
                                            <select
                                                required
                                                name="Manufacturer"
                                                id="p_Manufacturer"
                                                title="Manufacturer"
                                                className="form-control form-control-user"
                                                placeholder="Manufacturer"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_manufacturer: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Manufacturer
                                                </option>
                                                {
                                                    manufacturs?.map((v) => {
                                                        return (
                                                            <option value={v.pb_name}>{v.pb_name}</option>
                                                        )
                                                    })
                                                }
                                                {/* <option value={'Manufacturer 01'}>Manufacturer 01</option>
                                                <option value={'Manufacturer 02'}>Manufacturer 02</option> */}
                                            </select>
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Price</div>
                                            <input
                                                required
                                                type="number"
                                                name="p_price"
                                                min={0}
                                                id="p_price"
                                                title="Price"
                                                className="form-control form-control-user"
                                                placeholder="Price"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_price: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >MSRP</div>
                                            <input
                                                required
                                                type="number"
                                                min={0}
                                                name="MSRP"
                                                id="p_boxes"
                                                title=" MSRP (Manufacturer's Suggested Retail Price)"
                                                className="form-control form-control-user"
                                                placeholder="MSRP (Manufacturer's Suggested Retail Price)"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_MSRP: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>
                                        {/* <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                            <input
                                                type="number"
                                                id="p_age"
                                                name="p_age"
                                                title="Age"
                                                className="form-control form-control-user"
                                                placeholder="Age"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_age: v.target.value
                                                    })
                                                }}
                                            />{" "}
                                            <br />
                                        </div> */}
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Color</div>
                                            <input
                                                required
                                                type="text"
                                                name="Color"
                                                id="p_color"
                                                title="Color"
                                                className="form-control form-control-user"
                                                placeholder="Color"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_color: v.target.value
                                                    })
                                                }}
                                            />
                                            <br />
                                        </div>

                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Type</div>
                                            <select
                                                required
                                                name="Type"
                                                id="p_Type"
                                                title="Type"
                                                className="form-control form-control-user"
                                                placeholder="Type"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_type: v.target.value
                                                    })
                                                }}
                                            >
                                                <option value selected disabled>
                                                    Type
                                                </option>
                                                <option value={'Single vision'}>Single vision</option>
                                                <option value={'multi vision'}>Multi vision</option>
                                            </select>
                                            <br />
                                        </div>

                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Expiry</div>
                                            <select
                                                required
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                selected={false}
                                                placeholder="Expiry"
                                                onChange={(v) => {
                                                    let obj = v.target.value;
                                                    obj = JSON.parse(obj);
                                                    let arr = prodData;
                                                    arr.p_exp_id = obj.exp_id;
                                                    arr.p_age = obj.exp_no_days;
                                                    
                                                    setProdData(arr);
                                                    // useForceUpdate();
                                                    // setProdData({
                                                    //     ...prodData,
                                                    //     p_age: v.target.value
                                                    // })
                                                }}
                                            >
                                                {/* <option selected = {false} /> */}
                                                {
                                                    expiries.map((v, i) => {
                                                        const spacing = Array.from(Array(2 * 1.5), () => '\u00A0');
                                                        return (
                                                            <>
                                                                <option
                                                                    key={i}
                                                                    selected={i == 0 ?true : false}
                                                                    value={JSON.stringify(v)}
                                                                    disabled={v.parent == 0 ? true : false}
                                                                >
                                                                    {v.parent != '0' && spacing}{v.exp_title}</option>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {/* <option value={1}>Daily</option>
                                                <option value={7}>Weekly</option>
                                                <option value={14}>Bi-Weekly</option>
                                                <option value={30}>Monthly</option> */}
                                            </select>
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Status</div>
                                            <select
                                                required
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Status"
                                                onChange={(v) => {
                                                    setProdData({
                                                        ...prodData,
                                                        p_status: v.target.value
                                                    })
                                                }}
                                            >
                                                <option selected value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                            <br />
                                        </div>
                                        <input
                                            type="submit"
                                            title="Save"
                                            // onClick={() => AddProd()}
                                            // href="javascript://"
                                            // id="add_product"
                                            className="btn btn-primary btn-user btn-block"
                                            style={{ backgroundColor: AppColors.primary, borderWidth: 0, width: "95%", marginLeft: "2%", color: 'white', fontFamily: 'RBo' }}
                                        />

                                        {/* </input> */}
                                    </div>
                                </form>
                            </div>


                            {/* /.container-fluid */}
                        </div>
                        {/* End of Main Content */}
                    </div>
                    {/* End of Content Wrapper */}
                </div>
                {/* End of Page Wrapper */}
                {/* Scroll to Top Button*/}
                <a className="scroll-to-top rounded" href="#page-top">
                    <i className="fas fa-angle-up" />
                </a>
                {/* Logout Modal*/}
                <div
                    className="modal fade"
                    id="logoutModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Ready to Leave?
                                </h5>
                                <button
                                    className="close"
                                    type="button"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Select "Logout" below if you are ready to end your current session.
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    type="button"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <a className="btn btn-primary" href="logout.php">
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AddProduct
